import React, { useState, useEffect } from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import TablaGeneral from "../../../components/TablaGeneral";
import Loader from "../../../components/Loader";
import configTable from "../../../hook/configTable";

const PlatillosPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = (id) => {
    console.log('eliminarItem', id);
    setIsLoading(true);
    try {
      fetch("/p_platillo",{
        method: "DELETE",
        headers:{
          "Content-Type": "application/json",
        },
        body: JSON.stringify({id})
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDatos([])
        cargarDatos();
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [datosTabla] = useState({
    titulo: "Platillos",
    ruta: "/platillo",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable,
    keySucursal: "ID_SUC_PSU"
  })

  const [cabecera] = useState([
    { title: "ID", key: "ID_PLA" },
    { title: "NOMBRE", key: "NOMBRE_PLA" },
    { title: "DESCRIPCION", key: "DESCRIPCION_PLA" },
    { title: "SUCURSAL", key: "NOMBRE_SUCURSAL_SUC" },
    // { title: "ESTATUS", key: "ESTATUS_TEXTO" },
    { title: "FECHA_ALTA", key: "FECHA_ALTA_PLA", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/p_platillos",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if(data.status === 1){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default PlatillosPage;
